<template>
<!--  <el-dialog title="智能经营分析" :visible.sync="showBox" class="analysis-dialog" @close="closeAnalysis" :close-on-click-modal="false">-->
    <div>
      <transition name="fade">
        <loading v-if="isLoading"></loading>
      </transition>
      <div style="padding: 10px;">
        <div class="sales-data-list">
          <div v-for="(item,index) of salesData" :key="index" class="sales-data-item" :class="colorList[index]">
            <div style="padding-bottom: 5px;">
              <span style="font-size: 12px">{{item.icon}}</span>
              <span style="font-size: 20px">{{item.num}}</span>
            </div>
            <div style="color: #666;font-size: 14px;">{{item.name}}</div>
          </div>
        </div>
        <el-table
          :data="tableData"
          class="analysis-table"
          style="width: 100%">
          <el-table-column
            label="序号"
            type="index"
            align="center"
            width="70">
          </el-table-column>
          <el-table-column
            prop="name"
            label="诊断结果"
            align="center"
          >
            <template slot-scope="scope">
              <div v-if="!scope.row.param">{{scope.row.name}}</div>
              <div v-else>
                <span>{{scope.row.name1}}</span>
                <span style="color:#FD5D8A">{{scope.row.param}}</span>
                <span>{{scope.row.name2}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop=""
            label="建议操作"
            align="center"
            width="180">
            <template slot-scope="scope">
              <el-button v-if="scope.row.code == '1'" type="text" @click="toDetail(scope.row)">引入新品</el-button>
              <el-button v-else type="text" @click="toDetail(scope.row)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
<!--  </el-dialog>-->
</template>
<script>
import api from "@/config/api";
import Loading from '@/components/template/loading'
export default {
  components: {Loading,},
  data() {
    return {
      tableData:[],
      colorList:['color1','color2','color3','color4','color5','color6',],
      salesData:['9999.00','344.34','9999.00','344.34','9999.00','344.34'],
      isLoading:true,
      // showBox:false,
    }
  },
  mounted() {
    this.getAnalysis()
  },
  methods:{
    // 查看详情
    toDetail(row){
      this.$emit('close')
      let menu = null
      let userInfo = this.$utils.getSysUser()
      let storeId = null
      if(!userInfo.storeId){
        storeId = -1
      }
      let timeParam = {
        // edCreateDttm : this.$moment().format("YYYY-MM-DD 00:00:00"),
        // stCreateDttm :  this.$moment().subtract(30, "days").format("YYYY-MM-DD 23:59:59")// 往前30天
        edCreateDttm:row.edCreateDttm,
        stCreateDttm:row.stCreateDttm,
        storeId:storeId,
        salesNumber:row.salesNumber,
      }
      if(row.code == '1'){
        menu = {
          url:'/archives/goods/info',
          name:'goodsInfo',
          menuName:'商品档案',
        }
      }
      if(row.code == '2'){
        menu = {
          url:'/retail/query/sales/summary',
          name:'salesSummary',
          menuName:'销售汇总',
        }

      }
      if(row.code == '3'){
        menu = {
          url:'/archives/query/info',
          name:'qInfo',
          menuName:'商品档案综合查询',
        }
      }
      if(row.code == '4'){
        menu = {
          url:'/warehouse/query/inventory',
          name:'queryInventory',
          menuName:'库存查询',
        }
      }
      if(row.code == '5'){
        menu = {
          url:'/report/sales/Statistical',
          name:'Statistical',
          menuName:'商品销售统计',
        }
      }
      if(row.code == '6'){
        menu = {
          url:'/report/sales/Statistical',
          name:'Statistical',
          menuName:'商品销售统计',
        }
      }
      if(row.code == '7' || row.code == '8'){
        menu = {
          url:'/retail/query/customer/situation',
          name:'cSituation',
          menuName:'客单分析',
        }
      }
      // if(row.code == '9'){
      //   menu = {
      //     url:'/member/consume/record',
      //     name:'会员消费记录',
      //     menuName:'会员消费记录',
      //   }
      // }
      if(row.code == '10'){
        const { href } = this.$router.resolve({
          path: "/member/guide",
          query: ''
        });
        window.open(href, "_blank");
      }
      if(row.code == '11'){
        window.open('https://www.shopmedia.cn/scxcx', '_blank');
      }
      if(menu){
        this.$router.push({name:menu.name,params:{code:row.code,timeParam:timeParam}})
        this.addMenuList(menu)
      }
    },
    // 添加头部 记录菜单
    addMenuList(menu) {
      let menuList = this.$utils.getClickMenu().filter(v=>v.url!='/index')
      menuList.map((item) => {
        item.active = false;
      });
      let currentMenu = menuList.filter((item) => {
        return item.url === menu.url;
      });
      if (currentMenu.length === 0) {
        menu.active = true;
        menu.name = menu.menuName
        menu.url = menu.url
        menuList.push(menu);
      } else {
        currentMenu[0].active = true;
      }
      this.$utils.setClickMenu(menuList);
      this.$store.commit(this.$utils.storeKeys.CLICKMENU, menuList);
    },
    // 获取智能经营分析数据
    getAnalysis(){
      this.salesData = []
      this.tableData = []
      this.$axios.fetchPost(api.businessAnalysis).then(res=>{
        if(res.code === 200){
          if(res.data){
            this.salesData.push(
              {name:'今日销售',num:res.data.dayAnalysis?res.data.dayAnalysis:0,icon:'￥'},
              {name:'本月销售',num:res.data.monthAnalysis?res.data.monthAnalysis:0,icon:'￥'},
              {name:'本年销售',num:res.data.yearAnalysis?res.data.yearAnalysis:0,icon:'￥'},
              {name:'本月新增会员数',num:res.data.monthAddMember?res.data.monthAddMember:0,icon:''},
              {name:'本月会员消费',num:res.data.monthConsumptionMember?res.data.monthConsumptionMember:0,icon:'￥'},
              {name:'本月商品销售数量',num:res.data.monthConsumptionGoods?res.data.monthConsumptionGoods:0,icon:''},
            )
            this.tableData = res.data.list
            this.tableData.forEach(v=>{
              if(v.param){
                v.name1 = v.name.split(v.param)[0]
                v.name2 = v.name.split(v.param)[1]
              }
            })
          }
        }else{
          this.$message.error(res.errorMsg || '数据获取失败')
        }
      }).finally(()=>{
        setTimeout(()=>{
          this.isLoading = false
        },2000)
      })
    },
  },
}
</script>
<style scoped>
.sales-data-list{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.sales-data-item{
  width: 31%;
  height:90px;
  border-radius: 5px;
  margin-bottom: 10px;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.color1{
  background-color: #EEF4FF;
  color:#0054FE;
}
.color2{
  background-color: #ECF7FF;
  color:#1493FF;
}
.color3{
  background-color: #FDFAF2;
  color:#FFA518;
}
.color4{
  background-color: #FFF3F7;
  color:#FD5D8A;
}
.color5{
  background-color: #EFF9F4;
  color:#2ED48C;
}
.color6{
  background-color: #F6F5FF;
  color:#7559FF;
}
.analysis-dialog >>>.el-dialog{
  border-radius: 8px;
}
.analysis-dialog >>>.el-dialog__header{
  border-radius: 8px;
}
.analysis-table{
  max-height:calc(70vh - 280px);
  overflow-y:auto;
}
.el-table::before {
  z-index: inherit;
}
.analysis-table tr{
  height:30px;
  line-height: 30px;
}
div::-webkit-scrollbar {
  width: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/business/analysis.vue